<template>
  <div ref="mapContainer" class="map"></div>
</template>

<script>
export default {
  name: 'GoogleMap',
  props: {
    center: {
      type: Object,
      default: () => ({ lat: 43.4142989, lng: -124.2301242 }),
    },
  },
  data () {
    return {
      map: null,
      marker: null,
    }
  },
  mounted () {
    if (window.google && window.google.maps) {
      this.initMap()
    } else {
      window.initMap = () => {
        this.initMap()
      }
    }
  },
  methods: {
    initMap () {
      this.map = new window.google.maps.Map(this.$refs.mapContainer, {
        center: this.center,
        zoom: 13,
        mapId: "91e2d33af98c587d5961d6f1",
        disableDefaultUI: true,
        zoomControl: true,
        fullscreenControl: true,
      })
      const pin = new window.google.maps.marker.PinElement({
        background: "black",
        borderColor: 'black',
        glyphColor: "black",
      })
      this.marker = new window.google.maps.marker.AdvancedMarkerElement({
        position: this.center,
        map: this.map,
        content: pin.element,
      })
    },
  },
}
</script>

<style>
.map {
  width: 100%;
  height: 400px;
}
</style>
